<template>
  <section class="layout-main">
    <router-view :key="key" />
  </section>
</template>

<script>
export default {
  name: 'Main',
  computed: {
    key() {
      return this.$route.fullPath
    },
  },
}
</script>

<style scoped lang="scss">
.layout-main {
  min-height: calc(100vh - 260px);
  background-color: #f3f6f7;
}
</style>
